module.exports = __webpack_public_path__ + "static/media/tablet.30844532.jpg";